/**
 * Создаёт функцию, которая проверяет, что переданный элемент
 * подходит под поисковый запрос
 *
 * @param query - поисковый запрос
 * @example
 *  const filter = createFilterSearch('a b');
 *  filter('abc') -> false
 *  filter('aec bcd') -> true
 *  filter('bce daf') -> false
 */
export function createFilterSearch(query) {
    if (!query)
        return function () { return true; };
    var keywords = query
        .toLowerCase()
        .split(' ')
        .filter(function (x) { return x; });
    if (keywords.length === 0)
        return function () { return true; };
    return function (item) {
        var itemLower = item.toLowerCase();
        var index = 0;
        var newIndex;
        var find = false;
        for (var _i = 0, keywords_1 = keywords; _i < keywords_1.length; _i++) {
            var keyword = keywords_1[_i];
            newIndex = itemLower.indexOf(keyword, index);
            if (newIndex >= index) {
                index = newIndex;
                find = true;
            }
            else {
                find = false;
                break;
            }
        }
        return find;
    };
}
/**
 * Фильтрует массив по поисковому запросу с учетом порядка слов
 *
 * @param query - поисковый запрос
 * @param array - массив который фильтруем
 * @param field - свойство массива с именем
 */
export function filterSearch(query, array, field) {
    if (!query)
        return array ? array : [];
    if (!array)
        return [];
    var checkItem = createFilterSearch(query);
    return array.filter(function (object) {
        var item;
        if (field) {
            if (typeof field === 'string') {
                item = object[field];
            }
            else if (typeof field === 'function') {
                item = field(object);
            }
            else {
                throw new Error("Argument 'field' should be either string or function. Got " + typeof field);
            }
        }
        else {
            item = object;
        }
        return checkItem(item);
    });
}
//# sourceMappingURL=filterSearch.js.map